import React, { ChangeEvent, useEffect, useState } from "react";
import { LinearProgress, makeStyles, Button } from "@material-ui/core";
import CopyToClipboard from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import InputAdornment from '@material-ui/core/InputAdornment';

import useDebounce from "../../hooks/useDebounce";
import { HTTPMethods } from "../../yoello-lib/modules/API/API";
import APIExtensions from "../../yoello-lib/modules/API/APIDefs";
import useAPI from "../../yoello-lib/modules/API/useAPI";
// import useAPI from "../../yoello-lib/modules/API/useAPI";
import ICommonFormProps from "../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps";
import FormTextBox from "../../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";

function isSuccessfulColour(isSuccesful: boolean | null) {
  if (isSuccesful === null) {
    return "#FFDD02";
  }

  return isSuccesful ? "#4BB543" : "red";
}

/**Custom colours for handling if the Venue nickname is taken */
const useStyles = (isSuccesful: boolean | null) =>
  makeStyles((theme) => ({
    root: {
      "& label.Mui-focused": {
        color: isSuccessfulColour(isSuccesful),
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: isSuccessfulColour(isSuccesful),
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: isSuccesful !== null && isSuccessfulColour(isSuccesful),
        },
        "&:hover fieldset": {
          borderColor: isSuccesful !== null && isSuccessfulColour(isSuccesful),
        },
        "&.Mui-focused fieldset": {
          borderColor: isSuccessfulColour(isSuccesful),
        },
      },
    },
  }));

interface IVenueNicknameLookup extends ICommonFormProps {
  setError: any;
  clearError: any;
  disabled: boolean;
}
export function VenueNicknameLookup(props: IVenueNicknameLookup) {
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation();
  const [venueNickname, setVenueNickname] = useState("");
  const { debouncedValue } = useDebounce(venueNickname, 500);
  const [isSuccessfulNickname, setIsSuccessfulNickname] = useState<
    boolean | null
  >(null);
  console.log(venueNickname);
  const { callAPI, isLoading, cancelRequest } = useAPI(
    APIExtensions.venueNameSearch,
    () => null,
    {
      doNotCacheValue: true,
      onMountDisabled: true,
    }
  );

  const classes = useStyles(isSuccessfulNickname)();

  useEffect(() => {
    console.log("remount");
    if (props.register) {
      props.register(props.keyName, { ...props.registerOptions });
    }
    if (props.value) {
      setVenueNickname(props.value);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (props.disabled) {
      setIsSuccessfulNickname(true);
    }
  }, [props.disabled]);

  useEffect(() => {
    if (props.disabled) {
      return;
    }

    if (debouncedValue.length > 0) {
      cancelRequest();
      callAPI(HTTPMethods.GET, {
        query: debouncedValue,
      }).then((result) => {
        /**If the reuslt is undefined then API has failed */
        if (result === undefined) {
          props.setError(props.keyName, {
            type: "manual",
            message: t("qrCode.venueUrl.taken"),
          });
          setIsSuccessfulNickname(false);
        } else {
          setIsSuccessfulNickname(true);
          if (props.setValue) {
            props.setValue(props.keyName, debouncedValue)!;
          }
          if (props.clearError) {
            props.clearError(props.keyName);
          }


        }
      });
    } else if (isSuccessfulNickname) {
      setIsSuccessfulNickname(null);
    }
    // eslint-disable-next-line
  }, [debouncedValue]);

  useEffect(() => {
    if (venueNickname.length === 0 && isSuccessfulNickname !== null) {
      setIsSuccessfulNickname(null);
    }
    // eslint-disable-next-line
  }, [venueNickname, isSuccessfulNickname]);

  function onHandleChange(ev: ChangeEvent<HTMLInputElement>) {
    const value = ev.target.value;
    const regex = /^[a-zA-Z0-9-_]+\S*$/;
    /**No spaces allowed */
    if ((isMaxLength(value) && regex.test(value)) || value.length === 0) {
      setVenueNickname(value.toLowerCase());
    }
  }

  function isMaxLength(value: string) {
    if (props?.registerOptions?.maxLength) {
      const maxLength = props?.registerOptions?.maxLength;
      if (maxLength <= value.length) {
        return false;
      }
    }
    return true;
  }

  const baseUrl = `https://pay.yoello.com/v/`
  const venueUrl = `${baseUrl}${venueNickname}`;

  const inputProps = {
    ...props.inputProperties,
    onChange: onHandleChange,
    value: venueNickname,
    helperText: t("qrCode.venueUrl.instruction"),
    disabled: props.disabled,
    InputProps: {
      startAdornment: (
        <InputAdornment position="start">
          {baseUrl}
        </InputAdornment>
      ),
    },
  };

  return (
    <>
      <div style={{ minHeight: "2rem" }}>
        {
          isLoading && <LinearProgress />
        }
      </div>
      <Grid container spacing={2}>
        <Grid item xs={10}>
          <FormTextBox
            {...props}
            register={undefined as any}
            value={venueNickname}
            inputProperties={inputProps}
            className={classes.root}
          />
        </Grid>
        <Grid item xs={2} alignItems={'center'} justify={"center"}>
          <CopyToClipboard text={venueUrl} onCopy={() => setCopied(true)}>
            <Button
              variant="contained"
              color="primary"
              disabled={isLoading || !isSuccessfulNickname}
              fullWidth
              style={{ height: "53.63px", marginTop: "1.5rem" }}
            >
              {t(`qrCode.${copied ? "copied" : "copy"}`)}
            </Button>
          </CopyToClipboard>
        </Grid>

      </Grid>

    </>
  )

}
